import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import fetchAndStoreCategories from './util/FetchCategories';

const root = ReactDOM.createRoot(document.getElementById('root'));

fetchAndStoreCategories().then(() => {
  // console.log('✅ Categories ready -11111111111 />');
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
